import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, EMPTY, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthStateService } from '../states/auth-state.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isHandling401 = false;

  constructor(
    private router: Router,
    private authState: AuthStateService,
    private toastr: ToastrService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Solo tratamos como sesión caducada si había sesión iniciada; un login
        // fallido (también 401) debe propagar su mensaje normal.
        if (error.status === 401 && (this.authState.isLoggedIn() || this.isHandling401)) {
          if (!this.isHandling401) {
            this.isHandling401 = true;
            this.authState.setUser(null);
            this.toastr.error('Vuelve a iniciar sesión.', 'Sesión caducada');
            this.router.navigate(['/login']).then(() => {
              this.isHandling401 = false;
            });
          }
          return EMPTY; // no propagar -> sin toasts crudos ni vacíos
        }
        return throwError(() => error);
      })
    );
  }
}
